module.exports = __webpack_public_path__ + "static/media/cbse2025.a16d6069.jpg";